import { themeColors } from 'assets/theme/style';
import styled from 'styled-components';
import { DividerProps } from './Divider';

export const DividerLine = styled.div<DividerProps>`
  display: flex;
  height: 1px;
  border: none;
  background-color: ${({ color }) => (color ? color : themeColors.white)};
  margin: ${({ margin }) => (margin ? margin : '4px 0')};
`;
